import { useState, useEffect } from 'react'
import { supabase } from '../../../api/supabase'

interface PendingPOA {
  id: string
  user_email: string
  review_status: string
  created_at: string
}

export default function PendingReview() {
  const [poaList, setPOAList] = useState<PendingPOA[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPendingPOAs = async () => {
      try {
        const { data, error } = await supabase
          .from('poas')
          .select('id, user_email, review_status, created_at')
          .eq('review_status', 'pending_review')

        if (error) throw error
        setPOAList(data || [])
      } catch (err) {
        console.error('Error fetching POAs:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchPendingPOAs()
  }, [])

  if (loading) {
    return <div className="container mx-auto py-8">Loading...</div>
  }

  return (
    <div className="container mx-auto py-8">
      <h1 className="text-3xl font-bold mb-6">Pending POA Review</h1>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 px-4 py-2">Email</th>
              <th className="border border-gray-300 px-4 py-2">Status</th>
              <th className="border border-gray-300 px-4 py-2">Created</th>
              <th className="border border-gray-300 px-4 py-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {poaList.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center py-4">
                  No pending POAs
                </td>
              </tr>
            ) : (
              poaList.map((poa) => (
                <tr key={poa.id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-2">{poa.user_email}</td>
                  <td className="border border-gray-300 px-4 py-2">{poa.review_status}</td>
                  <td className="border border-gray-300 px-4 py-2">{new Date(poa.created_at).toLocaleDateString()}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    <button className="text-blue-600 hover:underline">Review</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
